<app-header-component
  [headerData]="currentHeaderData"
  (closeModal)="closeModal()"
></app-header-component>
<ion-content class="ion-bg-white" scrollY="false">
  <ion-grid class="ion-no-padding">
    <ion-row class="ion-no-padding">
      <ion-col class="ion-no-padding filter-category" size="5">
        <ion-list
          *ngFor="let item of filter"
          class="ion-list-transparent-bg-color"
        >
          <ion-item class="filter-category-item" (click)="getCategory(item)">
            <ion-item
              lines="none"
              [ngClass]="
                category === item.displayName
                  ? 'active-category filter-item ion-no-margin'
                  : 'filter-item ion-no-margin'
              "
            >
              <ion-label
                class="fs-2 font500 padl10 ion-label-primary-text-color"
              >
                {{ item.displayName }}</ion-label
              >
            </ion-item>
          </ion-item>
        </ion-list>
      </ion-col>
      <ion-col class="ion-no-padding filter-subcategory" size="7">
        <ion-list
          *ngFor="let item of subCategory"
          class="ion-list-transparent-bg-color"
        >
          <ion-item class="ion-item-white-bg-color">
            <ion-checkbox
              mode="ios"
              [checked]="isChecked(item)"
              class="marl10 primary-checkbox marr10"
              (ionChange)="getCheckedItem($event, item)"
              aria-label="agree"
              labelPlacement="end"
              justify="start"
            >
              <ion-label
                class="ion-label-primary-text-color"
                [class]="
                  isChecked(item) ? 'marl4 fs-2 font600' : 'marl4 fs-2 font500'
                "
              >
                {{ item.name }}</ion-label
              >
            </ion-checkbox>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <div class="footer-btn-container">
      <ion-button
        (click)="resetFilter()"
        class="ion-no-margin outline-btn fs-3 font500 marr8"
      >
        {{ "modals.filter_modal.reset" | translate }}
      </ion-button>
      <ion-button
        (click)="applyFilter()"
        class="ion-no-margin fs-3 font500 primary-btn"
      >
        {{ "modals.filter_modal.apply" | translate }}
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
